
<div v-if="getDiscount.length > 0" class="popup-discount" :class="{ 'popup-discount-small': small }">
  <el-popover placement="bottom" trigger="click">
    <div v-if="!small" slot="reference">
      <div class="popup-discount-button">Réductions
      </div>
    </div>
    <div v-else slot="reference">
      <div class="calendar-day-discount-button">%</div>
    </div>
    <div class="popup-discount-content">
      <div class="popup-discount-content-row" v-for="discount in getDiscount">
        <h2 class="popup-discount-content-row-hours">{{ discount.hourStart }} - {{ discount.hourEnd }}</h2>
        <div class="popup-discount-content-row-discount">
          <h2>-{{ discount.discount }}%</h2>
        </div>
      </div>
    </div>
  </el-popover>
</div>
